import React, { useState, useEffect } from 'react'
import { Box, Flex, Group, Button, FocusTrap, NumberInput, Select } from '@mantine/core'
import { DateInput } from '@mantine/dates'
import { addUserPoint, updateUserPoint } from '../../../../../services/users'
import { useUserPointForm } from './schema/form'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'
import { useParams } from 'react-router-dom'

const defaultTypeBalance = [
  {
    value: 'increase',
    label: 'Increase'
  },
  {
    value: 'decrease',
    label: 'Decrease'
  }
]

const defaultIncreaseType = [
  {
    value: 'increase',
    label: 'Point Adjustment'
  },
  {
    value: 'bonus',
    label: 'Bonus Point'
  }
]

const defaultDecreaseType = [
  {
    value: 'decrease',
    label: 'Point Adjustment'
  },
  {
    value: 'withdrawal',
    label: 'Redeem Point'
  }
]

const defaultTypePoint = {
  1: 'increase',
  4: 'bonus',
  2: 'decrease',
  5: 'withdrawal'
}

const FormAdjustUserPoint = ({ dataUserPoint, onCloseForm, reloadList }) => {
  const params = useParams()
  const userId = params.id
  const [loadingForm, setLoadingForm] = useState(false)

  const form = useUserPointForm()

  const submitUserPoint = async (form) => {
    setLoadingForm(true)
    let methodFunction = null
    let titleMessageSuccess = ''
    let captionMessageSuccess = ''
    let titleMessageError = ''
    let captionMessageError = ''

    if (dataUserPoint !== null) {
      methodFunction = updateUserPoint(userId, dataUserPoint.id, form)
      titleMessageSuccess = 'Update User Point Success'
      captionMessageSuccess = 'User Point has been updated successfully.'
      titleMessageError = 'Update User Point Failed'
      captionMessageError = 'User Point failed to update, please try again.'
    } else {
      methodFunction = addUserPoint(userId, form)
      titleMessageSuccess = 'Create User Point Success'
      captionMessageSuccess = 'User Point has been created successfully.'
      titleMessageError = 'Create User Point Failed'
      captionMessageError = 'User Point failed to create, please try again.'
    }

    try {
      const response = await methodFunction
      if (response.success) {
        notificationSuccess(titleMessageSuccess, captionMessageSuccess)
        setLoadingForm(false)
        reloadList()
        onCloseForm()
      }
    } catch (error) {
      const errorMessage = error.response.data.message
      notificationError(titleMessageError, errorMessage ? errorMessage : captionMessageError)

      const errorMessageForm = error.response.data.errors
      if (errorMessageForm) {
        Object.keys(errorMessageForm).forEach((key) => {
          form.setFieldError(key, errorMessageForm[key][0])
        })
      }
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    if (dataUserPoint !== null) {
      handleSetForm(dataUserPoint)
    }
    // eslint-disable-next-line
  }, [dataUserPoint])

  const handleSetForm = (data) => {
    const detail = {
      date: new Date(data.updated_at),
      value: data.amount,
      method: data.reward_type.value === 2 || data.reward_type.value === 5 ? 'decrease' : 'increase',
      type: defaultTypePoint[data.reward_type.value]
    }

    form.initialize(detail)
    form.setValues(data)
  }

  return (
    <Box>
      <FocusTrap.InitialFocus />
      <Box mb='sm'>
        <DateInput
          label="Date"
          placeholder="Date input"
          valueFormat="DD MMMM YYYY"
          key={form.key('date')}
          {...form.getInputProps('date')}
          clearable
          size='xs'
          withAsterisk
        />
      </Box>
      <Box mb='sm'>
        <NumberInput
          label="Point Amount"
          placeholder="Input point amount"
          key={form.key('value')}
          {...form.getInputProps('value')}
          size='xs'
          withAsterisk
        />
      </Box>
      <Box mb='sm'>
        <Select
          label="Type Balance"
          placeholder='Select Type Balance'
          data={defaultTypeBalance}
          key={form.key('method')}
          {...form.getInputProps('method')}
          onChange={(val) => form.setValues((prev) => ({ ...prev, method: val, type: null }))}
          allowDeselect={false}
          size='xs'
          withAsterisk
        />
      </Box>
      <Box mb='sm'>
        <Select
          label="Type Point"
          placeholder='Select Type Point'
          data={form.getValues().method === 'increase' ? defaultIncreaseType : defaultDecreaseType}
          key={form.key('type')}
          {...form.getInputProps('type')}
          allowDeselect={false}
          size='xs'
          withAsterisk
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={form.onSubmit((value) => submitUserPoint(value))}>{dataUserPoint !== null ? 'Update' : 'Create'}</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustUserPoint